import { setLoginUsernameCookie } from '@/common/loginCookie.js';

/**
 * 将 LoginUserVo 写入 sessionStorage / store，与 Login.vue 登录成功逻辑对齐。
 * 调用方：views/embed/EmbedEntry.vue
 */
export function applyEmbedLoginResult(vm, loginUser) {
  sessionStorage.setItem('TOKEN', loginUser.loginToken);
  sessionStorage.setItem('UID', loginUser.userId);
  sessionStorage.setItem('UNAME', loginUser.username);
  sessionStorage.setItem('ORGID', loginUser.orgId);
  sessionStorage.setItem('ROLEIDLIST', JSON.stringify(loginUser.roleIdList || []));
  sessionStorage.setItem('WORKCODES', JSON.stringify(loginUser.workCodes || []));
  sessionStorage.setItem('ROLEID', loginUser.roleId);
  sessionStorage.setItem('ROLENAME', loginUser.roleName);
  sessionStorage.setItem('NICKNAME', loginUser.nickName);
  // 与 Login.vue 登录成功一致，写入 username Cookie 供请求携带
  setLoginUsernameCookie(vm, loginUser.nickName);
  sessionStorage.setItem('MOBILE', loginUser.mobile);
  sessionStorage.setItem('EMAIL', loginUser.email);
  sessionStorage.setItem('PLATFORMCODE', loginUser.platformCode);
  sessionStorage.setItem('PLATFORMNAME', loginUser.platformName);
  sessionStorage.setItem('shouldHideReturnFields', loginUser.isExternalAudit === 1);
  sessionStorage.setItem('MENULIST', JSON.stringify(loginUser.menuList || []));
  sessionStorage.setItem('ALLENTERPRISEINFOLIST', JSON.stringify(loginUser.enterpriseInfoList || []));
  sessionStorage.setItem('PAYTYPELIST', JSON.stringify(loginUser.payTypeList || []));
  sessionStorage.setItem('userInfo', JSON.stringify(loginUser));

  let enterpriseInfoList = [];
  if (loginUser.enterpriseInfoList && loginUser.enterpriseInfoList.length > 0) {
    loginUser.enterpriseInfoList.forEach((val) => {
      if (loginUser.orgIdList && loginUser.orgIdList.indexOf(val.companyCode) !== -1) {
        enterpriseInfoList.push(val);
      }
    });
  }
  sessionStorage.setItem('ENTERPRISEINFOLIST', JSON.stringify(enterpriseInfoList));

  let qqsEnterpriseInfoList = [];
  if (enterpriseInfoList.length > 0 && loginUser.qqs) {
    enterpriseInfoList.forEach((val) => {
      if (loginUser.qqs.indexOf(val.companyCode) !== -1) {
        qqsEnterpriseInfoList.push(val);
      }
    });
  }
  sessionStorage.setItem('QQSENTERPRISEINFOLIST', JSON.stringify(qqsEnterpriseInfoList));

  vm.$store.dispatch('set_name', loginUser.username);
  vm.$store.commit('SET_TOKEN', loginUser.loginToken);
  sessionStorage.setItem('EMBED_MODE', 'true');
}

/**
 * 嵌入登录后预拉与主站一致的字典数据。
 * 调用方：views/embed/EmbedEntry.vue
 */
export function dispatchEmbedBootstrapStore(vm) {
  vm.$store.dispatch('getTopLists', 1);
  vm.$store.dispatch('getTopLists', 3);
  vm.$store.dispatch('getTopLists', 4);
  vm.$store.dispatch('getTopLists', 5);
  vm.$store.dispatch('getTopLists', 7);
  vm.$store.dispatch('getTopLists', 10);
  vm.$store.dispatch('getTopLists', 11);
  vm.$store.dispatch('getTopLists', 13);
  vm.$store.dispatch('getTopLists', 15);
  vm.$store.dispatch('getTopLists', 16);
  vm.$store.dispatch('getTopLists', 18);
  vm.$store.dispatch('getdropdownList', 2);
  vm.$store.dispatch('getdropdownList', 4);
  vm.$store.dispatch('getdropdownList', 17);
  vm.$store.dispatch('getdropdownList', 19);
}
